import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Unicons from '@iconscout/react-unicons';

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y, Autoplay, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";

import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default function Projects() {
    const navigate = useNavigate();

    // --------------------------------------------------
    // FORCE BOOK WITH id:1 ALWAYS FIRST
    // --------------------------------------------------
    const books = [
        { 
            id: 1, 
            book_name: "Knitted Together", 
            file: "/books/Knitted_Together.pdf", 
            desc: "Textile", 
            author: "Pramod John",
            extra_text: "Knitted Together, Multi-stakeholder perspectives in socio-economic and environmental issues in Tirupur garment cluster."
        },
        { 
            id: 2, 
            book_name: "Bitter Beans", 
            file: "/books/Bitter_Beans.pdf", 
            desc: "Beans", 
            author: "Pramod John",
            extra_text: "Bitter Beans, the coffee crisis and its impact in India."
        },
        
        {
            id: 3,
            book_name: "Burning issue",
            file: "/books/Burning_issue.pdf",
            desc: "Textile",
            author: "Pramod John",
            extra_text: "Environmental concerns and grassroots-level observations."
        },
        {
            id: 4,
            book_name: "Darjeeling Report",
            file: "/books/Darjeeling_Report_For Digital_Print.pdf",
            desc: "Tea",
            author: "Pramod John",
            extra_text: "A comprehensive review of Darjeeling agricultural challenges."
        },
        { 
            id: 5, 
            book_name: "Bonsucro Trichy Report", 
            file: "/books/Bonsucro_Trichy_Workshop_Report.pdf", 
            desc: "Sugarcane", 
            author: "Pramod John",
            extra_text: "A report highlighting Bonsucro workshop outcomes."
        },
        {
            id: 6,
            book_name: "Prakrathi Anual Report 2024",
            file: "/books/Prakruthi Annual Report Feb 24.pdf",
            desc: "Textile",
        },
        
        {
            id: 7,
            book_name: " Problems and Perspectives of Tirupur Garment Supply Chain",
            file: "/books/Tirupur Book.pdf",
            //  extra_text: "A comprehensive review of Darjeeling agricultural challenges.",
            desc: "Textile",
        },
         { 
            id: 8, 
            book_name: "Steering coorporate social responsibility", 
            file: "/books/TSG.pdf", 
            desc: "Textile", 
            author: "Pramod John",
            // extra_text: "Knitted Together, Multi-stakeholder perspectives in socio-economic and environmental issues in Tirupur garment cluster."
        },
        // { 
        //     id: 9, 
        //     book_name: "Phased out and stitched up", 
        //     file: "/books/Phased Out & Stitched Up-Nepal.pdf.pdf", 
        //     desc: "Textile", 
        //     author: "Pramod John",
        //     // extra_text: "Bitter Beans, the coffee crisis and its impact in India."
        // },
        { 
            id: 11, 
            book_name: "Case Studies HUL", 
            file: "/books/case studies _HUL_Revised.pdf", 
            desc: "Sustainablity", 
            author: "Pramod John",
            // extra_text: "A report highlighting Bonsucro workshop outcomes."
        },
        // {
        //     id: 12,
        //     book_name: "Prakruthi Anual Report 2011-12",
        //     file: "/books/Prakruthi Annual Report 2011-12.pdf",
        //     desc: "Textile",
        //     author: "Pramod John",
        //     // extra_text: "Environmental concerns and grassroots-level observations."
        // },
        {
            id: 13,
            book_name: "Prakruthi Anual Report 2010-11",
            file: "/books/Prakruthi Annual Report 2010-11.pdf",
            desc: "Textile",
            author: "Pramod John",
            extra_text: "A comprehensive review of Darjeeling agricultural challenges."
        },
       
         { 
            id: 14, 
            book_name: " Corporate Social Responsibility- Assigning Value", 
            file: "/books/SANSAR book NEW.pdf", 
            desc: "Sustainablity", 
            author: "Pramod John"
         },
        { 
            id: 15, 
            book_name: "SANSaR Core Members Meeting", 
            file: "/books/SANSaR conference report.pdf", 
            desc: "Sustainablity", 
            author: "Pramod John",
           
        },
        { 
            id: 16, 
            book_name: "Launch of SANSAR and Corporate Social Responsibility: ", 
            file: "/books/SANSAR book with photos.pdf", 
            desc: "Sustainablity", 
            author: "Pramod John",
            
        },
        {
            id: 17,
            book_name: "Corporate Responsibility Initiatives Mile Stones 2010–201",
            file: "/books/UK Annual Report.pdf",
            desc: "Sustainablity",
            author: "Pramod John",
         
        },
        {
            id: 18,
            book_name: "Coorpotate Social Responsibility:Studying the sugar production process in Pakistan",
            file: "/books/Sugarcane Research Pakistan.pdf",
            desc: "Sugarcane",
            author: "Pramod John",
            extra_text: "A comprehensive review of Darjeeling agricultural challenges."
        },
        {
            id: 19,
            book_name: "Sustainable Certified Coffee in South India",
            file: "/books/Sustainable Certified Coffee in South India.pdf",
            desc: "Beans",
        },
        {
            id: 20,
            book_name: "Steering Coorporate Social Responsibility",
            file: "/books/Steering Group_Book_New.pdf",
            desc: "Cotton",
        },

        {
            id: 21,
            book_name: "Sustainabili-tea",
            file: "/books/Sustainabili-tea.pdf",
            desc: "Tea",
        },
        {
            id: 22,
            book_name: "Tea small holders in Indonesia",
            file: "/books/Tea Smallholder inIndonesia_Research Report.pdf",
            desc: "Tea",
        },
        {
            id: 23,
            book_name: "Sweet Responsibility",
            file: "/books/Sweet Responsibility_CSR issues in Indian sugar industry.pdf",
            desc: "Sugarcane",
        },
        {
            id: 24,
            book_name: "Phased Out & Stitched Up-Nepal",
            file: "/books/PassedOut  - Copy.pdf",
            desc: "Textile",
        },
        {
            id: 25,
            book_name: "Scoping Corporate Social  Responsibility in Afghanistan",
            file: "/books/Scoping Corporate Social  Responsibility in Afghanistan.pdf",
            desc: "Sustainablity",
        },
        {
            id: 26,
            book_name: "Prakrathi Anual Report 2009-10",
            file: "/books/Prakruthi Annual Report 2009-10.pdf",
            desc: "Textile",
        },

    ];
    const sortedBooks = books.sort((a, b) => (a.id === 1 ? -1 : b.id === 1 ? 1 : 0));
    const [activeTab, setActiveTab] = useState("Textile");
    const [thumbnails, setThumbnails] = useState({});
    const [activeIndex, setActiveIndex] = useState(0);
    const generateThumbnail = async (pdfUrl) => {
        try {
            const loadingTask = pdfjsLib.getDocument(pdfUrl);
            const pdf = await loadingTask.promise;
            const page = await pdf.getPage(1);
            const viewport = page.getViewport({ scale: 5.0 });
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            await page.render({ canvasContext: ctx, viewport }).promise;
            const thumbCanvas = document.createElement("canvas");
            const thumbCtx = thumbCanvas.getContext("2d");
            thumbCanvas.width = 300;
            thumbCanvas.height = 400;

            thumbCtx.drawImage(canvas, 0, 0, 300, 400);

            return thumbCanvas.toDataURL("image/png");
        } catch (err) {
            console.error("Thumbnail error:", err);
            return null;
        }
    };

    useEffect(() => {
        sortedBooks.forEach(async (b) => {
            const thumb = await generateThumbnail(b.file);
            setThumbnails((prev) => ({ ...prev, [b.id]: thumb }));
        });
    }, []);
    const categories = ["All", ...new Set(sortedBooks.map((b) => b.desc))];
const filteredBooks =
    activeTab === "All"
        ? sortedBooks
        : sortedBooks.filter((b) => b.desc === activeTab);


    return (
        <section className="relative md:py-24 py-16 dark:bg-slate-900" id="project">
            <div className="container">

                {/* Title */}
                <div className="grid grid-cols-1 pb-8 text-center">
                    <h3 className="mb-6 md:text-2xl text-xl font-semibold text-slate-900 dark:text-slate-100">
                        My Work & Projects
                    </h3>
                </div>

                
<div className="flex flex-wrap justify-center gap-4 mb-12">
    {categories.map((cat) => (
       <button
    key={cat}
    onClick={() => setActiveTab(cat)}
    className={`px-6 py-2 rounded-full text-sm font-medium transition-all
    ${
        activeTab === cat
            ? "bg-amber-600 !text-white shadow-md"
            : "bg-white dark:bg-slate-800 text-black dark:text-slate-200 border border-slate-300 dark:border-slate-600"
    }
`}

>
    {cat}
</button>

    ))}
</div>
{/* BOOK GRID — FIXED SIZE + MORE GAP */}
<div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">

    {filteredBooks.map((book) => (
        <div
            key={book.id}
       onClick={() => {
    const file = encodeURIComponent(book.file);
    const name = encodeURIComponent(book.book_name);
    // window.open(`/book/viewer?file=${file}&name=${name}`, "_blank");
    navigate(`/book/viewer?file=${file}&name=${name}`);

}}



            className="cursor-pointer group  overflow-hidden 
                       shadow-md bg-white dark:bg-slate-800 relative 
                       transition hover:shadow-xl"
           
        >
           
            <img
                src={thumbnails[book.id] || "/placeholder.jpg"}
                alt="thumb"
                className="w-full max-h-[180px] object-contain p-3 bg-gray-100 dark:bg-slate-700"

            />

            {/* TEXT */}
            
           {/* TEXT — HIDDEN EXTRA TEXT UNTIL HOVER */}
<div className="p-4 relative">
    {/* <h4 className="text-[16px] font-semibold text-slate-900 dark:text-slate-100 line-clamp-2">
        {book.book_name}
    </h4>

    <p className="text-amber-600 text-sm mt-1">
        {book.desc}
    </p> */}

    {/* HOVER REVEAL DESCRIPTION */}
    {book.extra_name && (
        <p
            className="
                absolute left-0 right-0 top-full mt-2
                bg-white dark:bg-slate-800 
                text-xs text-slate-600 dark:text-slate-400 
                p-3 rounded-lg shadow-lg
                opacity-0 group-hover:opacity-100 
                translate-y-2 group-hover:translate-y-0 
                transition-all duration-300
                z-20
            "
        >
            {book.desc}
        </p>
    )}
</div>


            {/* BOOK ICON HOVER */}
            <div
                className="absolute inset-0 bg-black/40 dark:bg-black/60 
                           opacity-0 group-hover:opacity-100 
                           flex items-center justify-center 
                           transition"
            >
                <div className="bg-amber-600 p-3 rounded-full shadow-lg">
                    <Unicons.UilBookOpen size={22} className="text-white" />
                </div>
            </div>
        </div>
    ))}
</div>




            </div>
        </section>
    );
}
